"use client";

import React from "react";
import UltraModernHomePage from "../components/UltraModernHomePage";

export default function HomePage() {
  return <UltraModernHomePage />;
}
